import { render, staticRenderFns } from "./IntercomChat.vue?vue&type=template&id=4f4707a0"
import script from "./IntercomChat.vue?vue&type=script&lang=js"
export * from "./IntercomChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports